import React from 'react'
import PropTypes from 'prop-types'
import styles from './badge.scss'

const Badge = (props) => {
  const { count } = props

  if (!count) return null

  return <span className={styles.container}>{count}</span>
}

Badge.defaultProps = {
  count: null
}

const { number, oneOfType, string } = PropTypes

Badge.propTypes = {
  count: oneOfType([number, string])
}

export default Badge
